import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import axios from 'axios';
import VueAxios from 'vue-axios';
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import ArgonDashboard from "./argon-dashboard";
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';



const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use( VueAxios , axios)
appInstance.use(ArgonDashboard);
appInstance.mount("#app");
appInstance.use(PrimeVue);
appInstance.use(ToastService)
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';

axios.defaults.baseURL = 'https://backend.jarvis-app.net/api';

console.log(`Bearer ${localStorage.getItem('auth-token')}`);
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('auth-token')}`
axios.interceptors.response.use(function (response) {
    return response
  }, function (error) {
    console.log(error.response.data)
    if (error.response.status === 401) {
        localStorage.removeItem('auth-token');
    //     $toast.add({
    //     severity: "success",
    //     summary: "successful",
    //     detail: "Logged Out",
    //     life: 3000,
    //   });
      router.push('/signin')
    }
    return Promise.reject(error)
  })